module.exports = __webpack_public_path__ + "static/fipcpinkblossom4-75227314326b95240199e9440145f49c.jpeg";